module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/container-bars-961d4db699ebd63fea4ebd6d0a44e69b.png";